import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertOctagon, CheckCircle2, Loader2, Send } from "lucide-react";
import { api } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

function BlockedAlert({ status }) {
  return (
    <div data-testid="email-blocked-alert" className="rounded-xl border border-red-300 bg-red-50 p-4 flex gap-3">
      <AlertOctagon style={{ width: 20, height: 20 }} className="text-red-600 shrink-0 mt-0.5" />
      <div className="text-sm text-red-900 space-y-1">
        <p className="font-bold">Le email non stanno partendo</p>
        <p data-testid="email-blocked-reason">{status.last_error}</p>
        <p className="text-red-700 text-xs">
          Ultimo errore: {fmtDateTime(status.last_error_at)}{status.last_error_subject ? ` · "${status.last_error_subject}"` : ""}
          {status.last_success_at ? ` · Ultimo invio riuscito: ${fmtDateTime(status.last_success_at)}` : ""}
        </p>
      </div>
    </div>
  );
}

export default function EmailHealthPanel({ defaultTo }) {
  const [status, setStatus] = useState(null);
  const [to, setTo] = useState(defaultTo || "");
  const [sending, setSending] = useState(false);

  const load = useCallback(() => {
    api.get("/super-admin/email-status").then(({ data }) => setStatus(data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const sendTest = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/super-admin/email-test", { to: to.trim() || null });
      toast.success(`Email di prova inviata a ${data.sent_to}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invio non riuscito");
    } finally { setSending(false); load(); }
  };

  return (
    <div data-testid="email-health-panel" className="mb-8 space-y-3">
      {status?.blocked && <BlockedAlert status={status} />}
      <div className="rounded-xl border border-slate-200 bg-card p-4 flex flex-col md:flex-row md:items-center gap-3">
        <div className="flex-1 text-sm text-slate-600">
          <p className="font-semibold text-slate-900 flex items-center gap-1.5">
            {status && !status.blocked && status.last_success_at && <CheckCircle2 data-testid="email-ok-icon" style={{ width: 16, height: 16 }} className="text-emerald-600" />}
            Casella email di sistema
          </p>
          <p data-testid="email-sender">Mittente: {status?.sender || "non configurato"}</p>
        </div>
        <Input data-testid="email-test-to-input" type="email" value={to} onChange={(e) => setTo(e.target.value)}
          placeholder="Destinatario prova" className="md:w-64" />
        <Button data-testid="email-test-send-btn" onClick={sendTest} disabled={sending} className="gap-1.5">
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Invia email di prova
        </Button>
      </div>
    </div>
  );
}
